import React from "react"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import RichTextOptions from "../rich-text/RichTextOptions"
import { SectionSwitcher } from "../../pages/{ContentfulPage.slug}"
import Linked from "../elements/Linked"

export default function CareersTwoColumnSection({
  leftColumnRichText,
  rightColumnRichText,
  leftColumn,
  rightColumn,
  header,
  contentfulid,
  includeHeader = true,
}) {
  return (
    <section
      id={contentfulid}
      className="max-w-screen-md lg:max-w-screen-lg 2xl:max-w-screen-2xl mx-auto overflow-hidden first:pt-24 px-4"
    >
      {includeHeader && (
        <h2 className="text-center md:text-right text-secondary text-5xl uppercase w-fit mb-12 mx-auto md:ml-auto">
          {header}
        </h2>
      )}
      <div className="flex flex-col md:grid max-w-screen-xl mx-auto prose text-left gap-8 grid-rows-2 grid-cols-1 md:grid-rows-1 md:grid-cols-5 prose-black prose-p:my-0 ">
        <div className="md:col-span-2">
          {leftColumn &&
            leftColumn.map((section, index) =>
              SectionSwitcher(section, "other", index, "careers")
            )}
          {leftColumnRichText &&
            renderRichText(leftColumnRichText, RichTextOptions)}
        </div>
        <div className="md:col-span-3">
          {rightColumnRichText && (
            <div
              id="katch-us-if-you-can"
              className="space-y-4 font-sans text-left mb-12"
            >
              {renderRichText(rightColumnRichText, RichTextOptions)}
            </div>
          )}
          {rightColumn &&
            rightColumn.map((section, index) => (
              <div className="first:my-auto">
                {SectionSwitcher(section, "other", index, "careers")}
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

const MenuLinks = () => {
  return (
    <div className="flex justify-start">
      {[
        { title: "Katch Us If You Can", link: "#katch-us-if-you-can" },
        { title: "Life At Katch", link: "#life-at-katch" },
        { title: "Our Job Openings", link: "#our-job-openings" },
      ].map(({ title, link }, index) => {
        const splitTitle = title.split(" ")
        const { top, bottom } = splitTitle.reduce(
          (acc, curr) => {
            if (acc.top.length + curr.length < 10 && acc.bottom.length === 0) {
              return { ...acc, top: `${acc.top} ${curr}` }
            } else {
              return { ...acc, bottom: `${acc.bottom} ${curr}` }
            }
          },
          { top: "", bottom: "" }
        )
        return (
          <Linked
            key={`anchor-links-${index}`}
            linkTo={link}
            className="uppercase py-4 mr-8 font-bold leading-6 font-sans text-secondary no-underline flex flex-col"
            underline={false}
          >
            <span>{top}</span>
            <span>{bottom}</span>
          </Linked>
        )
      })}
    </div>
  )
}
